//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ActionBase,
  Breadcrumb,
  Container,
  Typography,
} from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'
import { mapGetters, mapState } from 'vuex'

import BestReviews from '@internal-reviews/components/Best'
import { PAYMENT_ADVERTISING_TYPES } from '@payment'
import TrustList from '@reassurance/components/TrustList'
import { PRODUCT_SOURCE_TYPE } from '@tracking'

import CarrierFilters from '../../../../components/Filters/Carrier/CarrierFilters'
import LandingNavigation from '../../../../components/LandingNavigation'
import NoResultsBanner from '../../../../components/NoResults/Banner'
import SearchParams from '../../../../utils/SearchParams'
import { TAGLINE_DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from '../../Landing.constants'
import Advert from '../Advert'
import Hero from '../Hero'

import translations from './TopLanding.translations'

export const fetch = async ({ route, store, $config, redirect }) => {
  const { params } = route
  const countryCode = store.getters['config/country']
  const { FF_NEW_URL_FORMAT } = $config
  const useNewUrl = FF_NEW_URL_FORMAT.includes(countryCode)
  const queryParams = useNewUrl
    ? { id: params.uuid, pk: params.uuid }
    : { slug: params.category }

  await Promise.all([
    store.dispatch('landing/fetchProductLanding', queryParams),
    store.dispatch('landing/fetchLandingBreadcrumb', queryParams),
    store.dispatch('reviews/best/fetch', queryParams),
    store
      .dispatch('landing/fetchLandingSeoNavigation', queryParams)
      .catch(() => ({
        payload: {},
      })),
    store.dispatch('rates/landing/fetch', queryParams).catch(() => ({
      // fails silently
    })),
  ])

  if (useNewUrl) {
    const link = store.getters['landing/links'][countryCode]
    if (link && params.slugV2 !== link.params.slugV2) {
      redirect({
        type: 'internal',
        name: link.name,
        params: {
          locale: route.params.locale,
          slugV2: link.params.slugV2,
          uuid: link.params.uuid,
        },
      })
    }
  }

  return {}
}

export default {
  components: {
    ActionBase,
    Breadcrumb,
    TrustList,
    Advert,
    Hero,
    BestReviews,
    CarrierFilters,
    NoResultsBanner,
    LandingNavigation,
    Typography,
    Container,
  },

  computed: {
    ...mapState({
      bestSalesLandingLink: (state) => state.config.bestSalesLandingLink,
    }),
    ...mapGetters({
      country: 'config/country',
      searchHasResults: 'landingSearch/hasResults',
      filterWhitelist: 'landingSearch/filterWhitelist',
      shouldDisplayHeroAndRates: 'landing/shouldDisplayHeroAndRates',
      landingTitle: 'landing/title',
      landingHero: 'landing/hero',
      landingId: 'landing/landingId',
      landingTagline: 'landing/tagline',
      landingBreadcrumb: 'landing/breadcrumb',
      landingSeoNavigation: 'landing/landingSeoNavigation',
      ratings: 'rates/landing/get',
      bestReviews: 'reviews/best/get',
    }),

    dataSelectorAttribute: () => TAGLINE_DATA_SELECTOR_ATTRIBUTE_FOR_SEO,

    translations: () => translations,

    LP_HERO: () => PRODUCT_SOURCE_TYPE.LP_HERO,

    ADVERTISING_LANDING: () => PAYMENT_ADVERTISING_TYPES.LANDING,

    landingPageId() {
      return this.landingId === null ? '' : this.landingId.toString()
    },

    useNewUrl() {
      return this.$config.FF_NEW_URL_FORMAT.includes(this.country)
    },

    breads() {
      return this.landingBreadcrumb.map((bread) => {
        if (!bread.link) {
          return bread
        }

        return {
          ...bread,
          slug: this.useNewUrl
            ? {
                ...bread.link,
                params: {
                  ...bread.link.params,
                  slugV2: bread.link?.params?.slugV2,
                },
              }
            : bread.link,
        }
      })
    },

    searchParams() {
      const { query, hash, params, name } = this.$route
      const { category, uuid } = params

      const context = {
        source: name,
      }

      if (this.useNewUrl) {
        context.id = uuid
      } else {
        context.slug = category
      }

      return new SearchParams({
        query,
        hash,
        context,
        paramsWhitelist: this.filterWhitelist,
      })
    },

    hasTopFiltersRefinements() {
      const filters = this.searchParams.toFilters()

      return (
        Boolean(filters.sim_lock_state) ||
        Boolean(filters.compatible_carriers_facet)
      )
    },

    hasNoResultsNorFilters() {
      return !this.searchHasResults && !this.searchParams.hasUserFilters()
    },

    displayHeroAndReview() {
      return !this.hasNoResultsNorFilters && this.shouldDisplayHeroAndRates
    },

    displayAdvertBanner() {
      return !this.hasNoResultsNorFilters
    },

    displayCarrierFilter() {
      return this.searchHasResults
    },

    displayLandingNavigation() {
      return !isEmpty(this.landingSeoNavigation)
    },

    hasBestReviews() {
      return !isEmpty(this.bestReviews.reviews)
    },

    bestReview() {
      return this.hasBestReviews ? this.bestReviews.reviews[0] : {}
    },
  },
  methods: {
    redirectToReviews() {
      return document.querySelector('#landingReviews').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },
  },
}
